import React, { useEffect } from 'react';
import { IItemForGetShortInfo, IGetDishesShort } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getDishesShortBySubCategoryId } from 'backend/dishes';
import MultipleSelect from './components/MultipleSelect';
import style from './AdditionalDishMultipleSelect.module.scss';

interface IAdditionalDishMultipleSelect {
	setAdditionalDishes: (value: string[]) => void;
	selectedAdditionalDishes: string[];
	selectedAdditionalDishSubCategory: Nullable<string>;
	setFetchedAdditionalDishes: (value: IItemForGetShortInfo[]) => void;
}

const AdditionalDishMultipleSelect: React.FC<IAdditionalDishMultipleSelect> = ({
	selectedAdditionalDishes,
	selectedAdditionalDishSubCategory,
	setAdditionalDishes,
	setFetchedAdditionalDishes,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetDishesShort, string>(
		selectedAdditionalDishSubCategory ? getDishesShortBySubCategoryId : null,
		selectedAdditionalDishSubCategory || '',
	);

	useEffect(() => {
		refetch();
	}, [selectedAdditionalDishSubCategory]);

	useEffect(() => {
		if (response) {
			setFetchedAdditionalDishes(response.data.dishes);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.dishes || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					selectedAdditionalDishes={selectedAdditionalDishes}
					selectedAdditionalDishSubCategory={selectedAdditionalDishSubCategory}
					setAdditionalDishes={setAdditionalDishes}
				/>
			</div>
		</div>
	);
};

export default React.memo(AdditionalDishMultipleSelect);
